"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.executeTx = exports.deserializeTx = exports.serializeTx = exports.WebExtensionTxStatus = void 0;
const terra_js_1 = require("@terra-money/terra.js");
const rxjs_1 = require("rxjs");
const errors_1 = require("../errors");
var WebExtensionTxStatus;
(function (WebExtensionTxStatus) {
    WebExtensionTxStatus["PROGRESS"] = "PROGRESS";
    WebExtensionTxStatus["SUCCEED"] = "SUCCEED";
    WebExtensionTxStatus["FAIL"] = "FAIL";
    WebExtensionTxStatus["DENIED"] = "DENIED";
})(WebExtensionTxStatus = exports.WebExtensionTxStatus || (exports.WebExtensionTxStatus = {}));
function serializeTx(tx) {
    var _a, _b, _c;
    return {
        msgs: tx.msgs.map((msg) => msg.toJSON()),
        fee: (_a = tx.fee) === null || _a === void 0 ? void 0 : _a.toJSON(),
        memo: tx.memo,
        gasPrices: (_b = tx.gasPrices) === null || _b === void 0 ? void 0 : _b.toString(),
        gasAdjustment: (_c = tx.gasAdjustment) === null || _c === void 0 ? void 0 : _c.toString(),
        account_number: tx.account_number,
        sequence: tx.sequence,
        feeDenoms: tx.feeDenoms,
    };
}
exports.serializeTx = serializeTx;
function deserializeTx(tx) {
    return Object.assign(Object.assign({}, tx), { msgs: tx.msgs.map((msg) => terra_js_1.Msg.fromData(JSON.parse(msg))), fee: tx.fee ? terra_js_1.StdFee.fromData(JSON.parse(tx.fee)) : undefined });
}
exports.deserializeTx = deserializeTx;
function executeTx(wallet, network, tx) {
    return new rxjs_1.Observable((subscriber) => {
        const lcd = new terra_js_1.LCDClient({
            chainID: network.chainID,
            URL: network.lcd,
            gasPrices: tx.gasPrices,
            gasAdjustment: tx.gasAdjustment,
        });
        const { privateKey } = wallet;
        const key = new terra_js_1.RawKey(Buffer.from(privateKey, 'hex'));
        lcd
            .wallet(key)
            .createAndSignTx(deserializeTx(tx))
            .then((signed) => lcd.tx.broadcastSync(signed))
            .then((data) => {
            if (terra_js_1.isTxError(data)) {
                subscriber.next({
                    status: WebExtensionTxStatus.FAIL,
                    error: !!data.txhash
                        ? new errors_1.WebExtensionTxFailed(data.txhash, data.raw_log, data.raw_log)
                        : new errors_1.WebExtensionCreateTxFailed(data.raw_log),
                });
                subscriber.complete();
            }
            else {
                subscriber.next({
                    status: WebExtensionTxStatus.SUCCEED,
                    payload: {
                        txhash: data.txhash,
                        height: data.height,
                        raw_log: data.raw_log,
                    },
                });
                subscriber.complete();
            }
        })
            .catch((error) => {
            subscriber.next({
                status: WebExtensionTxStatus.FAIL,
                error: new errors_1.WebExtensionTxUnspecifiedError('message' in error ? error.message : String(error)),
            });
            subscriber.complete();
        });
    });
}
exports.executeTx = executeTx;
//# sourceMappingURL=tx.js.map